var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.07 39.9092H12.19C9.87593 39.9092 8 41.7851 8 44.0992V51.2192C8 53.5333 9.87593 55.4092 12.19 55.4092H18.07C20.3841 55.4092 22.26 53.5333 22.26 51.2192V44.0992C22.26 41.7851 20.3841 39.9092 18.07 39.9092Z",
    fill: "#9A958C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6305 39.9092H81.7505C79.4365 39.9092 77.5605 41.7851 77.5605 44.0992V51.2192C77.5605 53.5333 79.4365 55.4092 81.7505 55.4092H87.6305C89.9446 55.4092 91.8205 53.5333 91.8205 51.2192V44.0992C91.8205 41.7851 89.9446 39.9092 87.6305 39.9092Z",
    fill: "#9A958C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1199 12H63.4999C65.4254 12 67.272 12.7649 68.6335 14.1264C69.995 15.4879 70.7599 17.3345 70.7599 19.26V54.06H28.6699V20.45C28.6699 18.2089 29.5602 16.0596 31.1449 14.4749C32.7296 12.8903 34.8788 12 37.1199 12Z",
    fill: "#9A958C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6909 67.3093V83.9493C84.6909 85.1808 84.2023 86.362 83.3324 87.2338C82.4626 88.1055 81.2824 88.5966 80.0509 88.5993H75.8109C74.574 88.5966 73.3888 88.1034 72.5151 87.2279C71.6415 86.3524 71.1509 85.1661 71.1509 83.9293V75.0593H28.6709V83.9593C28.6695 84.5708 28.5476 85.176 28.3121 85.7403C28.0766 86.3046 27.7321 86.8169 27.2983 87.2479C26.8645 87.6789 26.35 88.0201 25.7842 88.252C25.2183 88.4839 24.6123 88.6019 24.0009 88.5993H19.7909C18.554 88.5966 17.3688 88.1034 16.4951 87.2279C15.6215 86.3524 15.1309 85.1661 15.1309 83.9293V67.5193C15.1335 66.1197 15.6906 64.7783 16.6803 63.7887C17.6699 62.799 19.0113 62.2419 20.4109 62.2393H79.6209C80.9655 62.2393 82.2551 62.7734 83.2059 63.7242C84.1567 64.675 84.6909 65.9646 84.6909 67.3093Z",
    fill: "#9A958C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoli);
export default __webpack_public_path__ + "static/media/stoli.cb057214c380fc5f90489b85952dfca6.svg";
export { ForwardRef as ReactComponent };